import React, { useState } from 'react';

import translator from 'utils/translator';
import useResponsiveQuery from 'utils/useResponsiveQuery';

import cardsImageSrc from 'assets/images/new-home-page/cards.png';
import integrationsImageSrc from 'assets/images/new-home-page/integrations.png';

import ScrollSection from '../ScrollSection';
import styles from './styles.module.scss';

const _t = (path: string) => translator.text(`homepage.${path}`);

function Create() {
  const isMobile = useResponsiveQuery();
  const [mute, setMute] = useState(true);

  return (
    <div className={`${styles.create} flex flex-col w-full items-center`}>
      <div className={styles.content}>
        <p className={styles.primaryTitle}>{_t('create.eyebrow')}</p>
        <p className={styles.subtitle}>{_t('create.subtitle')}</p>

        <div className={styles.videoContainer}>
          <video
            playsInline
            autoPlay
            loop
            muted={mute}
            disableRemotePlayback
            src={`https://assts.stories.sc/website/${isMobile ? 'mobile' : 'desktop'}/main_top.mp4`}
            className={mute ? styles.videoMuteCursor : styles.videoUnmuteCursor}
            onClick={() => setMute(!mute)}
            poster="https://assts.stories.sc/website/poster/maintop.jpg"
          />
          <div className={styles.cardsWrapper}>
            <img src={cardsImageSrc} alt="Storycards product cards" />
          </div>
          <div className={styles.integrationsWrapper}>
            <img src={integrationsImageSrc} alt="Storycards integrations" />
          </div>
        </div>

        <h2 className={styles.bridgeTitle}>{_t('create.title')}</h2>

        <ScrollSection sectionId="create" />
      </div>
    </div>
  );
}
export default Create;
